module.exports = __webpack_public_path__ + "static/media/purchase_order_quick_books.d2dcb4f2.svg";